import { ErrorAccessor } from "./ErrorAccessor.js";
import { TemporalFieldHelper } from "../fieldHelpers/helpers/TemporalFieldHelper.js";
import { UuidFieldHelper } from "../fieldHelpers/helpers/UuidFieldHelper.js";
class FieldAccessor {
  constructor(state, operations, fieldName, value, valueOnServer, defaultValue, errors, hasUnpersistedChanges, touchLog, getAccessor, schema) {
    this.state = state;
    this.operations = operations;
    this.fieldName = fieldName;
    this.value = value;
    this.valueOnServer = valueOnServer;
    this.defaultValue = defaultValue;
    this.errors = errors;
    this.hasUnpersistedChanges = hasUnpersistedChanges;
    this.touchLog = touchLog;
    this.getAccessor = getAccessor;
    this.schema = schema;
  }
  addError(error) {
    return this.operations.addError(this.state, ErrorAccessor.normalizeError(error));
  }
  clearErrors() {
    this.operations.clearErrors(this.state);
  }
  addEventListener(event, listener) {
    return this.operations.addEventListener(this.state, event, listener);
  }
  updateValue(newValue, options) {
    this.operations.updateValue(this.state, newValue, options);
  }
  hasValue(candidate) {
    return this.value === candidate;
  }
  isTouchedBy(agent) {
    return this.touchLog?.has(agent) ?? false;
  }
  get isTouched() {
    return this.isTouchedBy(FieldAccessor.userAgent);
  }
  get resolvedValue() {
    if (this.defaultValue === void 0) {
      return this.value;
    }
    return this.value === null ? this.defaultValue : this.value;
  }
  get asTemporal() {
    return new TemporalFieldHelper(this.getAccessor);
  }
  get asUuid() {
    return new UuidFieldHelper(this.getAccessor);
  }
}
((FieldAccessor2) => {
  FieldAccessor2.userAgent = "user";
})(FieldAccessor || (FieldAccessor = {}));
export {
  FieldAccessor
};
//# sourceMappingURL=FieldAccessor.js.map
